import { TblAttributeCommand } from "../model/TblAttributeCommand";
import { TblCategoryAttributeModel } from "../model/TblCategoryAttributeModel";

/**
 * Simple store để chia sẻ dữ liệu giữa các tab trong form Attribute
 * Thay thế localStorage phức tạp
 */
class AttributeFormStore {
  private static instance: AttributeFormStore;
  private attributeData: TblAttributeCommand | null = null;
  private selectedCategories: TblCategoryAttributeModel[] = [];
  private listeners: (() => void)[] = [];

  public static getInstance(): AttributeFormStore {
    if (!AttributeFormStore.instance) {
      AttributeFormStore.instance = new AttributeFormStore();
    }
    return AttributeFormStore.instance;
  }

  public setAttributeData(data: TblAttributeCommand) {
    this.attributeData = { ...data };
    this.notifyListeners();
  }

  public getAttributeData(): TblAttributeCommand | null {
    return this.attributeData ? { ...this.attributeData } : null;
  }

  public setSelectedCategories(categories: TblCategoryAttributeModel[]) {
    this.selectedCategories = [...categories];
    this.notifyListeners();
  }

  public getSelectedCategories(): TblCategoryAttributeModel[] {
    return [...this.selectedCategories];
  }

  public subscribe(callback: () => void) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== callback);
    };
  }

  private notifyListeners() {
    this.listeners.forEach((callback) => callback());
  }

  public reset() {
    this.attributeData = null;
    this.selectedCategories = [];
    this.notifyListeners();
  }

  public hasData(): boolean {
    return this.attributeData !== null;
  }

  public isValid(): boolean {
    return !!(
      this.attributeData?.attributeName && this.attributeData?.attributeCode
    );
  }
}

export default AttributeFormStore;
